@if (observability.bugReportingEnabled()) {
    <button
        type="button"
        class="navbar-button"
        title="Report a bug"
        aria-label="Report a bug"
        (click)="observability.openBugReport()"
    >
        <i class="fal fa-bug"></i>
    </button>
}
